export default __webpack_public_path__ + "static/m-team3-e2f1dd685c1b6b7cecbf394c440f1e78.jpg";